import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { AccStatusKind, RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { form_control } from "projects/sepidz-web-framework/src/lib/models/form-control.model";
import { Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { AccVoucherHeader } from "../models/accvoucherheader.model";

@Component({
  selector: "ngx-movement-voucher",
  templateUrl: "./movement-voucher.component.html",
  styleUrls: ["./movement-voucher.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MovementVoucherComponent extends BaseFormComponent<AccVoucherHeader> {
  headerColumns: form_control[] = [];
  datalist: AccVoucherHeader[] = [];
  DefaultValues: Dictionary = [];
  isLoading: boolean = false;
  isOk4Loading: boolean = false;
  constructor(__id: FormContainerModel, _tabsservice: TabularService, protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.tabsservice = _tabsservice;
    this._id = __id;
  }
  @ViewChild("Grid") public grid: KGridComponent;
  async ngOnInit() {
    this.currentrow = undefined;
    this.apiName = "AccVoucherHeader";
    this.areaName = "Accounting";
    this.label = "جابجایی اسناد";
    this.setHeaderColumns();
    super.ngOnInit();
  }
  setColumnAttribute() {
    this.columns = this.columns.filter((x) => x.name === "VoucherDate" || x.name === "Id");
  }
  setdefault() {
    this.formGroup = this.setFormGroup(this.model, this.columns);
  }
  addControl() {
    this.isOk4Loading = true;
  }
  onChanged($event) {
    if (!this.headerColumns || this.headerColumns.length <= 0) this.setHeaderColumns();
    let date = this.formGroup.controls["VoucherDate"].value;
    this.datalist = [];
    this.httpCommonService
      .create(this.apiName + "/MovementVoucher", {
        VoucherDate: date,
        FiscalYearId: this.accountService.authService.currentFiscalYear.Id,
        BranchId: this.accountService.authService.currentBranchId,
      })
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x: AccVoucherHeader[]) => {
          if (x) this.datalist = x.sort((a, b) => a.VoucherNo - b.VoucherNo).sort((a, b) => a.DailyNo - b.DailyNo);
          this.isLoading = false;
          this.grid.refreshData();
          this.cd.markForCheck();
        },
        (error) => {
          this.isLoading = false;
          this.sts.showDialog(`خطا در بار گذاری اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا");
        }
      );
  }
  moveUp() {
    if (!this.currentrow) this.sts.showDialog("هیچ سندی انتخاب نشده است.", "خطا");
    else {
      let preRow = this.datalist.find((x) => x.VoucherNo === this.currentrow.VoucherNo - 1 && x.DailyNo === this.currentrow.DailyNo - 1);
      if (preRow) {
        if (!this.isLoading) {
          this.isLoading = true;
          if (preRow.StatusKindCode >= AccStatusKind.Confirm) {
            this.sts.showDialog("اسناد بررسی شده /قطعی  غیر قابل ویرایش است.", "خطا");
            return;
          }
          if (this.currentrow.StatusKindCode >= AccStatusKind.Confirm) {
            this.sts.showDialog("اسناد بررسی شده /قطعی  غیر قابل ویرایش است.", "خطا");
            return;
          }
          preRow.VoucherNo++;
          preRow.DailyNo++;
          this.currentrow.VoucherNo--;
          this.currentrow.DailyNo--;
          preRow.State = RowState.Modify;
          this.currentrow.State = RowState.Modify;
          if (preRow.VoucherNo !== this.currentrow.VoucherNo && preRow.DailyNo !== this.currentrow.DailyNo) this._Save([preRow, this.currentrow]);
        }
      }
    }
  }
  moveDown() {
    if (!this.currentrow) this.sts.showDialog("هیچ سندی انتخاب نشده است.", "خطا");
    else {
      let nextId = this.datalist.find((x) => x.VoucherNo === this.currentrow.VoucherNo + 1 && x.DailyNo === this.currentrow.DailyNo + 1);
      if (nextId) {
        if (!this.isLoading) {
          this.isLoading = true;
          if (nextId.StatusKindCode >= AccStatusKind.Confirm) {
            this.sts.showDialog("اسناد بررسی شده /قطعی  غیر قابل ویارشی است.", "خطا");
            return;
          }
          if (this.currentrow.StatusKindCode >= AccStatusKind.Confirm) {
            this.sts.showDialog("اسناد بررسی شده /قطعی  غیر قابل ویارشی است.", "خطا");
            return;
          }
          nextId.VoucherNo--;
          nextId.DailyNo--;
          this.currentrow.VoucherNo++;
          this.currentrow.DailyNo++;

          nextId.State = RowState.Modify;
          this.currentrow.State = RowState.Modify;
          if (nextId.VoucherNo !== this.currentrow.VoucherNo && nextId.DailyNo !== this.currentrow.DailyNo) this._Save([nextId, this.currentrow]);
        }
      }
    }
  }
  voucherRenumber() {
    this.httpCommonService
      .get<AccVoucherHeader>("AccVoucherHeader/VoucherRenumber/" + this.accountService.authService.currentFiscalYear.Id + "/")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          if (x) {
            this.onChanged(this.model.VoucherDate);
            this.sts.showDialog("اسناد شماره گذاری شد.", "");
          }
        },
        (error) => this.sts.showDialog(`خطا در شماره گذاری اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا")
      );
  }

  setHeaderColumns() {
    this.headerColumns = [];
    this.headerColumns.push(<form_control>{
      label: "شماره سند",
      controlType: FormControlTypes.textbox,
      modelName: "VoucherNo",
      disabled: true,
      name: "VoucherNo",
      order: 0,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.headerColumns.push(<form_control>{
      label: "شماره عطف",
      controlType: FormControlTypes.textbox,
      modelName: "FixNo",
      disabled: true,
      name: "FixNo",
      order: 1,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.headerColumns.push(<form_control>{
      label: "شماره روزانه",
      controlType: FormControlTypes.textbox,
      modelName: "DailyNo",
      disabled: true,
      name: "DailyNo",
      order: 2,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.headerColumns.push(<form_control>{
      label: "شماره فرعی",
      controlType: FormControlTypes.textbox,
      modelName: "SlaveNo",
      disabled: true,
      name: "SlaveNo",
      order: 3,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.headerColumns.push(<form_control>{
      label: "تاریخ سند",
      controlType: FormControlTypes.textbox,
      modelName: "ShamsiVoucherDate",
      disabled: true,
      name: "ShamsiVoucherDate",
      order: 4,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.headerColumns.push(<form_control>{
      label: "دوره مالی",
      controlType: FormControlTypes.textbox,
      modelName: "Year",
      disabled: true,
      name: "Year",
      order: 5,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.headerColumns.push(<form_control>{
      label: "ماه مالی",
      controlType: FormControlTypes.textbox,
      modelName: "FiscalMonth",
      disabled: true,
      name: "FiscalMonth",
      order: 6,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.headerColumns.push(<form_control>{
      label: "وضعیت سند",
      controlType: FormControlTypes.textbox,
      modelName: "StatusKindTitle",
      disabled: true,
      name: "StatusKindTitle",
      order: 7,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.headerColumns.push(<form_control>{
      label: "نوع سیستم",
      controlType: FormControlTypes.textbox,
      modelName: "SystemKindTitlee",
      disabled: true,
      name: "SystemKindTitlee",
      order: 8,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.headerColumns.push(<form_control>{
      label: "نوع سند",
      controlType: FormControlTypes.textbox,
      modelName: "AccVoucherKindTitle",
      disabled: true,
      name: "AccVoucherKindTitle",
      order: 9,
      formVisible: true,
      listVisible: true,
      required: false,
    });
  }
  onRowSelected(event: AccVoucherHeader) {
    this.currentrow = event;
  }
  public _Save(entity: AccVoucherHeader[]) {
    if (!this.isSaving) {
      if (this.isValid()) {
        this.sts.showToast("info", "", "در حال ذخیره تغییرات...");
        this.isSaving = true;
        this.isSaved = false;
        this.httpCommonService
          .bulkUpdate(this.apiName.split("/")[0], entity)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (response) => {
              this.isSaving = false;
              this.onChanged(this.currentrow.ShamsiVoucherDate);
            },
            (error) => {
              this.isLoading = false;
              this.saveFailedHelper(error);
              this.onChanged(this.currentrow.ShamsiVoucherDate);
            }
          );
      }
    }
  }
}
